import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib';
import {
  cancelStandbyGetAlternativeOffersRequest,
  failStandbyGetAlternativeOffers,
  setStandbyGetAlternativeOffers,
  setStandbyGetAlternativeOffersFromApi,
  updateStandbyGetAlternativeOffers,
  updateStandbyGetAlternativeOffersFromApi,
} from './standby-get-alternative-offers.actions';

/**
 * Service to handle async StandbyGetAlternativeOffers actions
 */
@Injectable()
export class StandbyGetAlternativeOffersEffect {
  /**
   * Set the state with the reply content, dispatch failStandbyGetAlternativeOffers if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setStandbyGetAlternativeOffersFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setStandbyGetAlternativeOffers({ model: reply, requestId: action.requestId }),
        (error, action) => of(failStandbyGetAlternativeOffers({ error, requestId: action.requestId })),
        cancelStandbyGetAlternativeOffersRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failStandbyGetAlternativeOffers if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateStandbyGetAlternativeOffersFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateStandbyGetAlternativeOffers({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failStandbyGetAlternativeOffers({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
